import PathwayListContainer from './pathway_list_container';

const PathwayList = PathwayListContainer;
export default PathwayList;
